module.exports = __webpack_public_path__ + "static/media/rotate-icon.c827959a.png";